import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const defaultStyles = {
  position: 'absolute',
  backgroundColor: "var(--ds-surface-overlay, white)",
  padding: '.3rem .5rem',
  borderRadius: '3px',
  fontSize: '14px',
  boxShadow: `0px 8px 12px ${"var(--ds-shadow-overflow-perimeter, grey)"}`,
  lineHeight: '1em',
  pointerEvents: 'none',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 12,
  paddingBottom: 12,
  overflow: 'hidden',
  border: `1px ${"var(--ds-border, grey)"} solid`,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 4,
  zIndex: 999,
  display: 'flex',
  transition: 'transform 0.3s'
};
const Tooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    top,
    left,
    tooltipPortalElement,
    offsetLeft = 0,
    offsetTop = 0,
    style = defaultStyles,
    children,
    unstyled = false,
    applyPositionStyle = false
  } = _ref;
  const elem = /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: className,
    style: {
      top: top == null || offsetTop == null ? top : top + offsetTop,
      left: left == null || offsetLeft == null ? left : left + offsetLeft,
      ...(applyPositionStyle && {
        position: 'absolute'
      }),
      ...(!unstyled && style)
    },
    children: children
  });

  // Render via portal
  if (tooltipPortalElement) return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/createPortal(elem, tooltipPortalElement)
  });
  return elem;
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;